export default __webpack_public_path__ + "assets/966267f343ff31ba9491c81972e759c7.woff";